import React, { useCallback, useEffect, useState } from "react";
import SearchHeader from "./SearchHeader";
import StoreCard from "./StoreCard";
import classes from "./System.module.css";
import { fetchBranches } from "../../services/branch-service";

const SystemContainer = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [onlineOnly, setOnlineOnly] = useState(false);
  const [branches, setBranches] = useState([]);

  const filteredStores = branches.filter((store) => {
    const matchesSearch =
      store?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      store?.code?.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesOnline = onlineOnly
      ? store?.availability_status === "online"
        ? true
        : false
      : true;
    return matchesSearch && matchesOnline;
  });

  const onRefresh = useCallback(() => {
    const data = [];
    fetchBranches().then((resp) => {
      resp.result.rows.map((branch) => {
        return data.push({
          code: branch?.code,
          name: branch?.name,
          availability_status: branch?.availability_status,
          url: branch?.public_endpoint_info?.url,
          active:
            branch?.public_endpoint_info?.status === "active" ? true : false,
        });
      });
      setBranches(data);
    });
  }, []);

  useEffect(() => {
    onRefresh();
  }, [onRefresh]);

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <div className={classes["container"]}>
        <SearchHeader
          onSearchChange={setSearchQuery}
          onOnlineOnlyChange={setOnlineOnly}
          onRefresh={onRefresh}
        />
        <div className={classes["grid"]}>
          {filteredStores?.map((store, index) => (
            <StoreCard
              key={store?.code + index}
              code={store?.code}
              name={store?.name}
              isOnline={store?.availability_status === "online" ? true : false}
              url={store?.url}
              active={store?.active}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SystemContainer;
